import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { cjSearch } from "../lib/cj";
import { MarketCard } from "../components/market/MarketCard";

const SORTS = [
  { label: "Featured", value: "popular" },
  { label: "Newest", value: "newest" },
  { label: "Price: Low to High", value: "price_low" },
  { label: "Price: High to Low", value: "price_high" },
];

export const Shop = () => {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [sort, setSort] = useState("popular");
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setPage(1); setItems([]); setLoading(true);
    cjSearch({ q, page: 1, size: 48, sort })
      .then((d) => { if (!active) return; setTotal(d.count || 0); setItems(d.products || []); })
      .catch(() => { if (active) setItems([]); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [q, sort]);

  const loadMore = async () => {
    const np = page + 1;
    setPage(np);
    setLoading(true);
    try {
      const d = await cjSearch({ q, page: np, size: 48, sort });
      setItems((prev) => [...prev, ...(d.products || [])]);
    } catch { /* keep existing items */ }
    finally { setLoading(false); }
  };

  const hasMore = items.length < total;

  return (
    <div className="px-4 md:px-8 lg:px-12 mx-auto max-w-[1600px] py-8" data-testid="shop-page">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-6">
        <div>
          <h1 className="text-3xl sm:text-4xl font-black tracking-tighter font-display">{q ? `Search: "${q}"` : "Shop the Marketplace"}</h1>
        </div>
        <select data-testid="shop-sort" value={sort} onChange={(e) => setSort(e.target.value)}
          className="border border-black/20 px-4 py-2 text-sm bg-white outline-none focus:border-black rounded-md">
          {SORTS.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
        </select>
      </div>

      {items.length === 0 && !loading ? (
        <div className="border border-dashed border-black/15 py-24 text-center" data-testid="shop-empty">
          <p className="text-xl font-display font-bold">No products found</p>
          <p className="text-sm text-muted-foreground mt-1">Try a different search or sort.</p>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-3 md:gap-4" data-testid="shop-grid">
            {items.map((p) => <MarketCard key={p.taven_product_id || p.handle} product={p} />)}
          </div>
          {loading && <p className="text-center text-sm text-muted-foreground mt-8" data-testid="shop-loading">Loading…</p>}
          {hasMore && !loading && (
            <div className="text-center mt-10">
              <button onClick={loadMore} data-testid="shop-load-more"
                className="px-8 py-3 rounded-full bg-black text-white text-sm font-bold uppercase tracking-wider hover:bg-taven-gold hover:text-black transition-colors">
                Load More
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Shop;
